import { ReactElement } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RadioButton } from '~/components';
import { DamScheduleFormValues } from '../../types';

export function SelectPermission(): ReactElement {
  const {
    control,
    setValue,
  } = useFormContext<DamScheduleFormValues>();
  const { t } = useTranslation();

  const permissionWatch = useWatch<DamScheduleFormValues, 'permission'>({
    control,
    name: 'permission',
  });

  function handleSelectPermission(permission: 'allow' | 'forbid'): void {
    setValue('permission', permission);
  }

  return (
    <div style={{ paddingBottom: '20px', display: 'flex', gap: 8 }}>
      <RadioButton
        label={t('permitir')}
        checked={permissionWatch === 'allow'}
        onClick={() => handleSelectPermission('allow')}
        tabIndex={0}
      />
      <RadioButton
        label={t('desligar')}
        checked={permissionWatch === 'forbid'}
        onClick={() => handleSelectPermission('forbid')}
        tabIndex={0}
      />
    </div>
  );
}
